export default function formatDate(
  date: string,
  withTime?: boolean,
  withSeconds?: boolean,
): string {
  let formatedDate;

  if (Date.parse(date)) {
    const dateItem = new Date(date);

    const days = dateItem.getDate().toString().padStart(2, '0');
    const months = (dateItem.getMonth() + 1).toString().padStart(2, '0');
    const years = dateItem.getFullYear().toString();

    formatedDate = `${days}.${months}.${years}`;

    if (withTime) {
      formatedDate = `${formatedDate} ${dateItem
        .getHours()
        .toString()
        .padStart(2, '0')}:${dateItem
        .getMinutes()
        .toString()
        .padStart(2, '0')}${
        withSeconds
          ? `:${dateItem.getSeconds().toString().padStart(2, '0')}`
          : ''
      }`;
    }
  } else {
    formatedDate = '';
  }

  return formatedDate;
}
